export const HiddenWolfAudioData = {
    global: {
        tempo: 76,
        signature: [7, 8],
    },
    voiceover: {
        id: "hiddenWolf-voiceover",
    },
    background: {
        samplePool: ["string-harmonics"],
        volume: -24,
        loopStart: 4,
        loopEnd: 35,
        fadeOutDuration: 2,
    },
    // Set up the groups here
    sharedLoops: [
        {
            name: "celeste",
            samplePool: ["glass-celeste"],
            length: "8m",
            velocity: 0.8,
            volume: -6,
        },
        {
            name: "wolf-breath",
            samplePool: ["wolf-breath"],
            length: "4m",
            velocity: 0.8,
            volume: -6,
        },
        {
            name: "wolf-breath-minimal",
            samplePool: ["wolf-breath-minimal"],
            length: "4m",
            velocity: 0.8,
            volume: -6,
        },
        {
            name: "rhythm-guitar",
            samplePool: ["chug-guitar"],
            length: "4m",
            velocity: 0.8,
            volume: -6,
        },
        {
            name: "ambient-guitar",
            samplePool: ["guitar1"],
            length: "5m",
            volume: -6,
        },
    ],
    scenes: [
        // 0: TITLES
        {
            name: "Intro",
            fadeInDuration: 2,
            fadeOutDuration: 2,
            worldBackgroundVolume: -18,
            tracks: [
                { group: "celeste", volume: -128 }, // So it preloads
            ]
        },
        {
            name: "Sheep",
            fadeInDuration: 2,
            fadeOutDuration: 2,
            tracks: [
                { group: "celeste", volume: -6 },
            ],
            worldBackgroundVolume: -18,
        },
        {
            name: "Sheep 2",
            tracks: [
                { group: "celeste", volume: -6 },
                { group: "wolf-breath-minimal", volume: -6 },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 4,
            worldBackgroundVolume: -18,
        },
        {
            name: "High 1",
            tracks: [
                { group: "celeste", volume: -6 },
                { group: "wolf-breath-minimal", volume: -3 },
                {
                    samplePool: ["whales"],
                    length: "8m",
                    velocity: 0.8,
                },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 4,
            worldBackgroundVolume: -18,
            loopsVolume: -6,
        },
        {
            name: "Farmhouse & Boy",
            tracks: [
                { group: "celeste", volume: -6 },
                { group: "wolf-breath", volume: -3 },
                { group: "ambient-guitar" },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 8,
            worldBackgroundVolume: -18,
            loopsVolume: -6,
        },
        {
            name: "Boy close",
            tracks: [
                { group: "celeste", volume: -6 },
                { group: "wolf-breath", volume: 0 },
                { group: "rhythm-guitar", volume: -6 },
                { group: "ambient-guitar" },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 8,
            worldBackgroundVolume: -18,
            loopsVolume: -3,
        },
        {
            name: "Sheep pen high",
            tracks: [
                { group: "celeste", volume: -6 },
                { group: "wolf-breath", volume: 0 },
                { group: "rhythm-guitar", volume: -3 },
                {
                    samplePool: ["guitar2"],
                    length: "7m",
                    velocity: 0.8,
                },
            ],
            fadeInDuration: 4,
            fadeOutDuration: 8,
            worldBackgroundVolume: -16,
            loopsVolume: -6,
        },
    ]
};
